import React from 'react';
import Button from "../../../components/ui/button/button";
import {withRouter} from "../../../layouts/AdminLayout/AdminLayout";
import {ReactComponent as PlusIcon} from "../../../images/icons/ui/plus-icon.svg";
import TextField from "../../../components/TextField/TextField";
import {ReactComponent as OrderUpIcon} from "../../../images/icons/ui/order-up.svg";
import {ReactComponent as OrderDownIcon} from "../../../images/icons/ui/order-down.svg";
import {ReactComponent as TrashIcon} from "../../../images/icons/ui/trash-icon.svg";
import RadioSlider from "../../../components/ui/radioSlider/radioSlider";
import ImageUploader from "../../../components/ui/imageUploader/imageUploader";
import API from "../../../components/api";
import {SERVER_URL} from "../../../config";


class AdminPanelEmployeesPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            employees: [],

            tabValues: [
                {name: 'Prodoctorov', value: 'prodoctorov'},
                {name: 'Другое', value: 'other',},
                {name: 'Нет', value: 'no'},
            ],
        }

        this.changeEmployee = (name, index, value) => {
            let {employees} = this.state;

            employees[index][value] = name

            this.setState({
                employees: [...employees]
            });
        }

        this.addEmployee = () => {
            const {employees} = this.state;

            let employee = {
                id: -Math.random(),
                name: '',
                experience: 20,
                order: 0,
                image: '',
                url_type: 'no',
                url: '',
            }

            this.setState({
                employees: [employee, ...employees]
            });
        }

        this.updateEmployees = () => {
            API.adminGetEmployees()
                .then(data => this.setState({employees: data}))
                .catch(error => {
                })
        }

        this.saveEmployees = (employees) => {
            API.adminSaveEmployees(employees)
                .then(data => {
                    this.props.addSnackbar("Сотрудники успешно сохранены", {
                        icon: "PositiveCheckmark",
                        divider: true,
                        closeable: true,
                    });
                    this.updateEmployees()
                })
                .catch(error => {
                    this.props.addSnackbar("Не получилось сохранить сотрудников", {
                        icon: "AttentionAlert",
                        additionalText: 'Попробуйте еще раз или обновите страницу',
                        divider: true,
                        closeable: true,
                    });
                })
        }

        this.swapEmployee = (employeeId, side) => {
            const {employees} = this.state;

            const index = employees.findIndex(c => c.id === employeeId);
            if (index === -1) return;

            const targetIndex =
                side === 'up'
                    ? index - 1
                    : side === 'down'
                        ? index + 1
                        : index;

            if (targetIndex < 0 || targetIndex >= employees.length) {
                return;
            }

            const current = employees[index];
            employees[index] = employees[targetIndex];
            employees[targetIndex] = current;

            this.setState({employees: employees})
        }

        this.deleteEmployee = (employeeId) => {
            this.setState(prevState => {
                const employees = prevState.employees;
                const newEmployees = employees.filter(s => s.id !== employeeId);

                return {
                    employees: newEmployees
                };
            });
        };
    }

    componentDidMount() {
        this.updateEmployees()
    }

    render() {
        return <div className='admin-page-container'>
            <div className='header'>
                <div className='title'>
                    Сотрудники
                </div>
                <div className='controls'>
                    <Button type='accent' size='medium' onClick={() => {
                        this.saveEmployees(this.state.employees)
                    }}>
                        Сохранить изменения
                    </Button>
                    <Button type='primary' size='medium'
                            onClick={() => {
                                this.updateEmployees()
                            }}>
                        Отменить
                    </Button>
                </div>
            </div>
            <div className='content'>
                <Button type='transparent' size='large' fullWidth
                        startIcon={<PlusIcon/>}
                        onClick={() => {
                            this.addEmployee()
                        }}>
                    Добавить
                </Button>
                <div className='employees'>
                    {
                        this.state.employees.map((employee, index) => {
                            const urlType = employee.url_type;
                            return <div key={employee.id} className='employee'>
                                <div className='top'>
                                    <TextField label='ФИО Сотрудника' fullWidth
                                               value={this.state.employees[index].name}
                                               onChange={(e) => this.changeEmployee(e.target.value, index, 'name')}/>
                                    <div className='button-group'>
                                        <div className='buttons'>
                                            <div className='divider'/>
                                            <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                                    startIcon={<OrderUpIcon/>}
                                                    onClick={() => this.swapEmployee(employee.id, 'up')}/>
                                            <Button customClass='icon-size-24' type='secondary' size='medium' fullWidth
                                                    startIcon={<OrderDownIcon/>}
                                                    onClick={() => this.swapEmployee(employee.id, 'down')}/>
                                            <div className='divider'/>
                                            <Button type='primary' size='medium' fullWidth
                                                    startIcon={<TrashIcon/>}
                                                    onClick={() => this.deleteEmployee(employee.id)}/>
                                        </div>
                                    </div>
                                </div>
                                <TextField label='Стаж работы, лет' fullWidth
                                           value={this.state.employees[index].experience} type='number'
                                           onChange={(e) => this.changeEmployee(e.target.value, index, 'experience')}/>
                                <TextField label='Должность' fullWidth multiline
                                           value={this.state.employees[index].description}
                                           onChange={(e) => this.changeEmployee(e.target.value, index, 'description')}/>
                                <ImageUploader description='От 604 х 672, форматы jpeg, png' size='small'
                                               imageBase64={this.state.employees[index].image_base64}
                                               url={this.state.employees[index].image ? SERVER_URL + this.state.employees[index].image : null}
                                               uploadHandler={(b64) => this.changeEmployee(b64, index, 'image_base64')}/>
                                <div className='bottom'>
                                    {['prodoctorov', 'other'].includes(urlType) && (
                                        <TextField
                                            label={
                                                urlType === 'prodoctorov'
                                                    ? 'Ссылка на Prodoctorov'
                                                    : 'Ссылка на страницу сотрудника'
                                            }
                                            fullWidth
                                            value={employee.url}
                                            onChange={(e) =>
                                                this.changeEmployee(e.target.value, index, 'url')
                                            }
                                        />
                                    )}
                                    <RadioSlider value={this.state.employees[index].url_type}
                                                 buttons={this.state.tabValues} fullWidth
                                                 setValue={(value) => this.changeEmployee(value, index, 'url_type')}/>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        </div>
    }
}


export default withRouter(AdminPanelEmployeesPage);
